const brownA = {
  brownA1: "hsla(30, 94.3%, 34.6%, 0.012)",
  brownA2: "hsla(30, 94.3%, 34.6%, 0.036)",
  brownA3: "hsla(30, 97.7%, 33.9%, 0.083)",
  brownA4: "hsla(31, 98.5%, 34.2%, 0.134)",
  brownA5: "hsla(29, 100%, 34.3%, 0.200)",
  brownA6: "hsla(28, 99.2%, 34.6%, 0.291)",
  brownA7: "hsla(29, 99.8%, 33.8%, 0.412)",
  brownA8: "hsla(28, 100%, 33.3%, 0.553)",
  brownA9: "hsla(28, 99.9%, 25.5%, 0.655)",
  brownA10: "hsla(27, 99.7%, 22.4%, 0.675)",
  brownA11: "hsla(25, 99.8%, 17.3%, 0.714)",
  brownA12: "hsla(21, 99.4%, 6.6%, 0.867)"
};
export { brownA };
//# sourceMappingURL=brownA.mjs.map
